<template>
  <div class="screen">
    <div class="absolute-center">

      <div class="screen-2">
        <div class="container">
          <div class="arrow-left" @click="prevPerson()"></div>
          <div class="persons">

            <transition :name="transition">
              <div class="person" v-if="person === 'svetlana'" @click="linkTo('svetlana')" >
                <div class="person-image person-1"></div>
                <div class="person-text person-1">Погуляйте <br>
                  на свадьбе
                </div>
              </div>
            </transition>
            <transition :name="transition">
              <div class="person" v-if="person === 'elena'" @click="linkTo('elena')">
                <div class="person-image person-2"></div>
                <div class="person-text person-2">Пройдите
                  <br>
                  собеседование
                </div>
              </div>
            </transition>
            <transition :name="transition">
              <div class="person" v-if="person === 'maria'" @click="linkTo('maria')">
                <div class="person-image person-3"></div>
                <div class="person-text person-3">Отправьтесь
                  <br>
                  в путешествие
                </div>
              </div>
            </transition>

          </div>
          <div class="arrow-right" @click="nextPerson()"></div>
        </div>
        <div class="dots">
          <div class="dot" :class="(person ==='svetlana')?'active':''" @click="showPerson('svetlana')" v-if="contains('svetlana')"></div>
          <div class="dot" :class="(person ==='elena')?'active':''" @click="showPerson('elena')" v-if="contains('elena')"></div>
          <div class="dot" :class="(person ==='maria')?'active':''" @click="showPerson('maria')" v-if="contains('maria')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReadMoreMobile",
  props: ["persons"],
  data() {
    return {
      person: this.persons[0],
      transition: "slide-left"
    };
  },

  methods: {
      contains(person){
          return  this.persons.indexOf(person) !== -1
      },
      index(person){
          return  this.persons.indexOf(person)
      },

    linkTo(name) {
      this.$router.push(name);
    },
    nextPerson() {
      this.transition = "slide-left";
      this.person = (this.index(this.person) === 1) ? this.persons[0] : this.persons[1];
    },
    prevPerson() {
      this.transition = "slide-right";
        this.person = (this.index(this.person) === 1) ? this.persons[0] : this.persons[1];
    },
    showPerson(name) {
      this.transition = this.index(this.person) < this.index(name) ? "slide-left" : "slide-right";
      this.person = name;
    }
  }
};
</script>

<style scoped lang="scss">
.absolute-center {
}

.screen {
  width: 100%;
  min-height: 80vw;
  z-index: 3;
  position: relative;
  overflow: hidden;
}

h1 {
  font-family: "Playfair Display", serif;
  color: #323232;
  font-size: 32px; /* Приближение из-за подстановки шрифтов */
  font-weight: 700;
  font-style: italic;
  line-height: 20px; /* Приближение из-за подстановки шрифтов */
  text-align: center;
  margin-top: 31px;
}

.subHeader {
  font-family: "Roboto", sans-serif;
  color: #323232;
  font-size: 16px; /* Приближение из-за подстановки шрифтов */
  font-weight: 400;
  text-align: center;
}

.intro {
  width: 77vmin;
}

.arrow-down {
  margin: 0 auto;
  height: 11px;
  width: 15px;
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30.5' height='20.5'%3E%3Cpath fill-rule='evenodd' stroke='%23000' stroke-width='3' stroke-linecap='round' d='M4.146 4.854l.708-.708 10 10-.708.708-10-10zM24.666 4.624l.71.71-10.042 10.042-.71-.71L24.666 4.624z'/%3E%3C/svg%3E");
}

.arrow-top {
  margin: 0 auto;
  height: 11px;
  width: 15px;
  margin-bottom: 28px;
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30.5' height='20.5'%3E%3Cpath fill-rule='evenodd' stroke='%23000' stroke-width='3' stroke-linecap='round' d='M4.146 4.854l.708-.708 10 10-.708.708-10-10zM24.666 4.624l.71.71-10.042 10.042-.71-.71L24.666 4.624z'/%3E%3C/svg%3E");
  transform: rotate(180deg);
}

.arrow-left {
  height: 15px;
  width: 11px;
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='19.5' height='29.5'%3E%3Cpath fill-rule='evenodd' stroke='%23000' stroke-width='3' stroke-linecap='round' d='M13.724 3.628l.68.691-9.617 9.767-.68-.691 9.617-9.767zM13.945 23.67l-.683.693-9.657-9.808.682-.693 9.658 9.808z'/%3E%3C/svg%3E");
  // transform: rotate(180deg);
}

.arrow-right {
  height: 15px;
  width: 11px;
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='19.5' height='29.5'%3E%3Cpath fill-rule='evenodd' stroke='%23000' stroke-width='3' stroke-linecap='round' d='M13.724 3.628l.68.691-9.617 9.767-.68-.691 9.617-9.767zM13.945 23.67l-.683.693-9.657-9.808.682-.693 9.658 9.808z'/%3E%3C/svg%3E");
  transform: rotate(180deg);
}

.screen-2 {
  width: 81vw;
  max-width: 500px;
}

.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

p {
  font-family: "Roboto", sans-serif;
  color: #323232;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
}

.person {
  .person-text {
    font-family: "Playfair Display", serif;
    color: #323232;
    font-size: 25px;
    font-style: italic;
    line-height: 23px;
    text-align: left;
    background-repeat: no-repeat;
    background-size: auto 100%;
    padding-bottom: 17px;
    padding-top: 12px;
    display: block;
    margin: auto;

    &.person-1 {
      background-image: url("../assets/img/index/1.png");
      width: 120px;
    }
    &.person-2 {
      background-image: url("../assets/img/index/2.png");
      width: 140px;
    }
    &.person-3 {
      background-image: url("../assets/img/index/3.png");
      width: 180px;
    }
  }
  .person-image {
    background-repeat: no-repeat;
    background-size: contain;
    margin: 0 auto;

    &.person-1 {
      background-image: url("../assets/img/index/person1.png");
      width: 42vw;
      height: 62vw;
    }
    &.person-2 {
      background-image: url("../assets/img/index/person2.png");
      width: 42vw;
      height: 62vw;
    }
    &.person-3 {
      background-image: url("../assets/img/index/person3.png");
      width: 54vw;
      height: 62vw;
    }
  }
}

.dots {
  margin: 20px auto;
  width: 40px;
  display: flex;
  justify-content: space-between;
}

.dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  border: #f5f5f5 1px solid;
  box-shadow: 0 0 2px #323232;
  display: inline-flex;

  &.active {
    background-color: #cba76c;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ReadMoreMobile.vue